module.exports = __webpack_public_path__ + "media/images/flags/pa-a07fc86f41614b2d31652b0fde06f30e.svg";